import { render, staticRenderFns } from "./QuizFormResultButton.vue?vue&type=template&id=92af084c&scoped=true&"
import script from "./QuizFormResultButton.vue?vue&type=script&lang=js&"
export * from "./QuizFormResultButton.vue?vue&type=script&lang=js&"
import style0 from "./QuizFormResultButton.vue?vue&type=style&index=0&id=92af084c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92af084c",
  null
  
)

export default component.exports